module.exports = {"type":"FeatureCollection","name":"Incidence","features":[{"type":"Feature","id":0,"properties":{"name":"Wasp nest","category":"security","subcategory":"Plague","severity":"1-high","text":"Wasp nest in tree"},"geometry":{"type":"Point","coordinates":["-15.4310137","28.1084447"]}},{"type":"Feature","id":0,"properties":{"name":"Tree in bad conditions","category":"security","subcategory":"Tree_Fallen","severity":"1-high","text":"Tree with several death branches"},"geometry":{"type":"Point","coordinates":["-15.436167","28.124259"]}}]}


//////////////////
// WEBPACK FOOTER
// ./src/moks/las_palmas/parksandgardens/gisIncidence.json
// module id = xzHS
// module chunks = 1